import type { SiteContent } from '../types'

/**
 * First-paint placeholder — deliberately empty.
 *
 * The site's copy and imagery live in the CMS, not in this bundle. Keeping a
 * duplicate of the real text here is what previously let deleted CMS content keep
 * showing on the site, so the placeholder holds no content at all: the app renders
 * a loading state until the gateway answers.
 */
export const INITIAL_CONTENT: SiteContent = {
  home: {},
  settings: {},
  ministries: [],
}
